import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

import {
  alertNotification,
} from '../shared/store/actions';

import {
  sharedActions,
} from './store/actions';

class AccountMapAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      bsmAccount: PropTypes.string.isRequired,
      glAccount: PropTypes.string.isRequired,
      slGlJournalExists: PropTypes.number.isRequired,
    }),
    rowIndex: PropTypes.number.isRequired,
    showAccountMapModalForAddAndEdit: PropTypes.func.isRequired,
    showAccountMapModalForDelete: PropTypes.func.isRequired,
    showAlert: PropTypes.func.isRequired,
  };

  showAccountMapModalForAddAndEdit = () => {
    const { value, showAccountMapModalForAddAndEdit } = this.props;
    return showAccountMapModalForAddAndEdit(value);
  };

  showAccountMapModalForDelete = () => {
    const { value, showAccountMapModalForDelete, showAlert, rowIndex } = this.props;

    if (value.slGlJournalExists === 1) {
      return showAlert('Selected row cannot be deleted because the Map Name Account combination is used in a GL Journal definition for this period.');
    }

    return showAccountMapModalForDelete({
      entity: value,
      rowIndex,
    });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Account Map Settings"
          onClick={this.showAccountMapModalForAddAndEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showAccountMapModalForAddAndEdit: sharedActions.showModalForAddEdit,
    showAccountMapModalForDelete: sharedActions.showModalForRemove,
    showAlert: alertNotification,
  }
)(AccountMapAdminColumnRenderer);
